import styled from "styled-components";
import { colors } from "../../assets";

export const AlertContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 10px;
  max-width: max-content;
  border-radius: 4px;

  &.info {
    background-color: ${colors["msg-info"]};
  }

  &.error {
    background-color: ${colors["msg-danger"]};
  }
`;
